// extracted by mini-css-extract-plugin
module.exports = {"drawerContent":"drawerContent--D4UUZ","drawerHandle":"drawerHandle--3E3c_"};